const initialState = 1;

const searchResultsPaginationReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_SEARCH_RESULTS_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                  return 1;
            default:
                  break;
      }
      return state;
};
export default searchResultsPaginationReducer;